module.exports = __webpack_public_path__ + "img/oandb-qrcode.47406170.jpeg";